import { render, staticRenderFns } from "./RegistrationView.vue?vue&type=template&id=71b5bc6c&"
import script from "./RegistrationView.vue?vue&type=script&lang=ts&"
export * from "./RegistrationView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports